import { Component, OnInit } from '@angular/core';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';

@Component({
  selector: 'app-policy-guidelines',
  templateUrl: './policy-guidelines.component.html',
  styleUrls: ['./policy-guidelines.component.scss']
})
export class PolicyGuidelinesComponent implements OnInit {

  constructor(public userUtilsService:UserUtilService) { }

  ngOnInit(): void {
  }

}
